<template>
    <div class="feed-header flex">
        <div class="feed-info flex">
            <div class="name-wrapper">
                <p class="ad-name ellipsis">{{ advertise.name }}</p>
            </div>
            <div class="header-action-wrapper" v-if="scene=='feedList'">
                <span class="ad-tag">广告</span>
                <el-dropdown placement="bottom" trigger="click" @command="handleAcation">
                    <span class="arrow-down-wrapper">
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="1">屏蔽</el-dropdown-item>                       
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getFullDate } from '../../utils/date';
import { authorType } from '../../utils/feed';
import UserAvatar from '../../components/UserAvatar';
import { apiMap } from '../../utils/apiMap';
export default {
    name: 'ad-header',
    props: {
        advertise: {
            type: Object,
            required: true
        },
        scene: String,
    },
    data() {
        return {
            dialogVisible: false,
            clearDialog: true,
            reasonList: [],  
        }
    },
    methods: {
        handleAcation(action) {
            console.log(action);
        }
    }
}
</script>
<style scoped>
.feed-info {
    width: 99%;
    justify-content: space-between;
}

.name-wrapper {
    margin-left: 6px;
    line-height: 20px;
}

.name-wrapper .ad-name {
    max-width: 500px;
    font-size: 16px;
    line-height: 30px;
}

.name-wrapper .create-time {
    color: #999;
}

.header-action-wrapper {
    line-height: 30px;
}

.arrow-down-wrapper {
    width: 45px;
    height: 25px;
    display: inline-block;
    text-align: center;
    font-size: 17px;
    cursor: pointer;
}

.arrow-down-wrapper:hover {
    color: #FF6600;
}

.ad-tag {
    width: 42px;
    height: 17px;
    padding: 1px 5px;
    line-height: 17px;
    text-align: center;
    color: #888888;
    border: 1px solid #888888;
    border-radius: 8px;
}

.follow {
    padding: 4px 5px;
}

.report-tip {
    margin-left: 100px;
    margin-bottom: 10px;
}
</style>